module.exports = "img/videos/19.d4857f.mp4";